export const DELETED_RECORDS_RESTORABLE_DAYS_LIMIT = 90;
